import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigation = [
    { name: 'Features', href: '/features' },
    { name: 'How It Works', href: '/how-it-works' },
    {
      name: 'Solutions',
      dropdown: [
        { name: 'For Schools', href: '/for-schools' },
        { name: 'For Educators', href: '/for-educators' },
        { name: 'For Parents', href: '/for-parents' },
        { name: 'For Students', href: '/for-students' },
      ]
    },
    { name: 'Blog', href: '/blog' },
    { name: 'Giving Back', href: '/giving-back' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-50 glass-card border-b border-white/10">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5 group relative">
            {/* Glow effect behind logo */}
            <span
              className="absolute inset-0 text-3xl font-black text-[#06b6d4] blur-lg opacity-70 select-none"
              aria-hidden="true"
            >
              Lumen8
            </span>
            <span className="relative text-3xl font-black text-gradient">
              Lumen8
            </span>
          </Link>
        </div>

        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white hover:text-[var(--color-electric-blue)] transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="sr-only">Open main menu</span>
            {mobileMenuOpen ? (
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            ) : (
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            )}
          </button>
        </div>

        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            item.dropdown ? (
              <div key={item.name} className="relative group">
                <button className="text-base font-semibold leading-6 text-[var(--color-light-gray)] hover:text-white transition-colors">
                  {item.name}
                </button>
                <div
                  className="absolute left-0 mt-2 w-52 rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 premium-shadow"
                  style={{
                    background: 'rgba(15, 23, 42, 0.95)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                  }}
                >
                  <div className="py-2">
                    {item.dropdown.map((dropItem) => (
                      <Link
                        key={dropItem.name}
                        to={dropItem.href}
                        className="block px-5 py-3 text-base text-[var(--color-light-gray)] hover:bg-white/10 hover:text-white transition-all"
                      >
                        {dropItem.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <Link
                key={item.name}
                to={item.href}
                className="text-base font-semibold leading-6 text-[var(--color-light-gray)] hover:text-white transition-colors"
              >
                {item.name}
              </Link>
            )
          ))}
        </div>

        <div className="hidden lg:flex lg:flex-1 lg:justify-end gap-4">
          <Link
            to="/contact"
            className="btn-premium text-base font-semibold"
          >
            Request Demo <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden">
          <div className="space-y-1 px-6 pb-3">
            {navigation.map((item) => (
              item.dropdown ? (
                <div key={item.name}>
                  <div className="text-base font-semibold leading-7 text-[var(--color-wolf)] py-2">
                    {item.name}
                  </div>
                  <div className="ml-4">
                    {item.dropdown.map((dropItem) => (
                      <Link
                        key={dropItem.name}
                        to={dropItem.href}
                        className="block text-base leading-7 text-[var(--color-wolf)] hover:text-[var(--color-eel)] py-2 transition-colors"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        {dropItem.name}
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <Link
                  key={item.name}
                  to={item.href}
                  className="block text-base font-semibold leading-7 text-[var(--color-wolf)] hover:text-[var(--color-eel)] py-2 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              )
            ))}
            <div className="pt-4 border-t border-[var(--color-swan)]">
              <Link
                to="/contact"
                className="block text-base font-semibold leading-7 text-[var(--color-macaw)] hover:text-[var(--color-peacock)] py-2 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Request Demo <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;